import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { sortingActions } from '../actions/sorting.actions';
import { selectContents, selectProduct, selectSaving, selectScanning, selectSuggestions } from '../selectors/sorting.selector';

@Service()
export class SortingFacade {
    private readonly store = inject(Store);

    readonly product = this.store.selectSignal(selectProduct);
    readonly suggestions = this.store.selectSignal(selectSuggestions);
    readonly contents = this.store.selectSignal(selectContents);
    readonly scanning = this.store.selectSignal(selectScanning);
    readonly saving = this.store.selectSignal(selectSaving);

    scanProduct(ean: string): void {
        this.store.dispatch(sortingActions.scanProduct({ ean }));
    }

    addItem(cartonCode: string, ean: string): void {
        this.store.dispatch(sortingActions.addItem({ cartonCode, ean }));
    }

    clear(): void {
        this.store.dispatch(sortingActions.clear());
    }
}
